module.exports = __webpack_public_path__ + "static/media/beer.1dc7bc1e.gif";